// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";

// import { useAuthUser } from "react-auth-kit";
// import AppConfig from "appConfig";

function DataForms() {
  const pageTitle = "Data Forms";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  //   const auth = useAuthUser();
  //   const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [dataForms, setDataForms] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedDataForm, setSelectedDataForm] = useState(null);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);

  const [title, setTitle] = useState(null);
  const [openCreateFormDialog, setOpenCreateFormDialog] = useState(false);

  const [openAttachDialog, setOpenAttachDialog] = useState(false);
  const [selectAllCampaigns, setSelectAllCampaigns] = useState(false);

  async function duplicateForm(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/${ref}/duplicate.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteDataForm(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const tableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Added On", accessor: "created", align: "right" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((dataForm) => {
      rows.push({
        title: dataForm.title,
        actions: (
          <MDBox>
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                setSelectedCampaigns([]);
                setSelectedDataForm(dataForm.reference);
                setOpenAttachDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                move_up
              </Icon>
            </MDButton>
            {!dataForm.is_global ? (
              <>
                &nbsp;
                <MDButton
                  size="small"
                  variant="outlined"
                  color="warning"
                  iconOnly
                  onClick={() => {
                    navigate(`/data-forms/${dataForm.reference}`);
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    edit
                  </Icon>
                </MDButton>
                &nbsp;
                <MDButton
                  size="small"
                  variant="outlined"
                  color="info"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Duplicate this data form?`) === true) {
                      duplicateForm(dataForm.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    copy
                  </Icon>
                </MDButton>
                &nbsp;
                <MDButton
                  size="small"
                  variant="outlined"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Delete this data form?`) === true) {
                      deleteDataForm(dataForm.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    delete
                  </Icon>
                </MDButton>
              </>
            ) : (
              <> </>
            )}
          </MDBox>
        ),
        created: dataForm.is_global ? "SYSTEM" : dataForm.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/data_forms.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaigns(result.data.data.campaigns);
            const rows = buildRateRows(result.data.data.data_forms);
            setDataForms(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  useEffect(() => {
    if (!selectAllCampaigns) {
      setSelectedCampaigns([]);
      return;
    }

    if (campaigns.length <= 0) {
      return;
    }

    const tempArry = [];
    campaigns.every((row) => {
      tempArry.push(row.reference);
      return true;
    });

    setSelectedCampaigns(tempArry);
  }, [selectAllCampaigns]);

  async function attachToCampaigns() {
    if (selectedCampaigns.length <= 0) {
      setSeverity("error");
      setErrMsg("Please select a campaign.");
      setOpen(true);
      return;
    }

    // console.log(selectedCampaigns);

    if (selectedDataForm === null) {
      setSeverity("error");
      setErrMsg("Data form is required");
      setOpen(true);
      return;
    }

    setOpenAttachDialog(false);
    setShowLoading(true);

    const json = {
      data_form: selectedDataForm,
      campaigns: selectedCampaigns,
    };

    await axios
      .post("portal/data_forms/campaigns/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  // const handleChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectedCampaigns(
  //     // On autofill we get a stringified value.
  //     typeof value === "string" ? value.split(",") : value
  //   );
  // };

  async function createDataForm() {
    if (title === null) {
      setErrMsg("Form name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setOpenCreateFormDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
    };

    await axios
      .post("portal/data_forms/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          navigate(`/data-forms/${result.data.data.reference}`);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openCreateFormDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Form</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateFormDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              createDataForm();
            }}
          >
            Create Form
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach To Campaigns</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Campaign(s)</InputLabel>
                <Select
                  multiple
                  value={selectedCampaigns}
                  label="Select Campaign(s)"
                  // onChange={handleChange}
                  onChange={(e) => {
                    setSelectedCampaigns(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  // renderValue={(selected) => selected.join(", ")}
                  renderValue={(selected) => {
                    let renderString = "";
                    selected.every((ref) => {
                      campaigns.every((row) => {
                        if (row.reference === ref) {
                          renderString += `${row.title}, `;
                          return false;
                        }
                        return true;
                      });
                      return true;
                    });

                    return renderString.replace(/, +$/, "");
                  }}
                >
                  {
                    // --> Notice below changes
                    campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      campaigns.map((record) => (
                        <MenuItem value={record.reference}>
                          <Checkbox checked={selectedCampaigns.indexOf(record.reference) > -1} />
                          <ListItemText
                            primary={
                              <MDTypography variant="caption" fontSize={14}>
                                {record.title}
                              </MDTypography>
                            }
                          />
                        </MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={selectAllCampaigns}
                onChange={(e) => {
                  setSelectAllCampaigns(e.target.checked);
                }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Select All Campaigns?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              attachToCampaigns();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox>
            {dataForms.length > 0 ? (
              <MDBox mt={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          Data Forms
                        </MDTypography>
                      </MDBox>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          // navigate("/data-forms/create");
                          setOpenCreateFormDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                    <MDBox mt={5}>
                      <DataTable
                        table={{ columns: tableColumns, rows: dataForms }}
                        isSorted
                        entriesPerPage
                        showTotalEntries
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            ) : (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon>dynamic_form</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                          Need to capture specific information? Ideal for enumerations,
                          on-boardings, customer information and more.
                          <br />
                          Create your first data form and attach to your campaigns.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5} mb={3}>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            // navigate("/data-forms/create");
                            setOpenCreateFormDialog(true);
                          }}
                          startIcon={<Icon>add</Icon>}
                        >
                          Create Form
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DataForms;
